import { resetReturnDate } from 'components/Cart/actions';
import { addMonths } from 'date-fns';
import { useDispatch } from 'react-redux';
import { getDefaultDays, Props } from './rentalPeriod';
import {
  calculateReturnRangeStartDate,
  calculateReturnRangeEndDate,
  isValidPickupDate
} from 'views/CheckoutPage/components/utils';
import styles from './rentalPeriod.scss';
import { rm } from 'utils';
import { Calendar } from 'views/CheckoutPage/components/Calendar';

interface StartProps
  extends Pick<
    Props,
    | 'item'
    | 'setReturnDate'
    | 'setPickupDate'
    | 'selectedReturnDate'
    | 'dispatchRentalPeriod'
    | 'selectedPickupDate'
    | 'shouldBeDisabled'
  > {
  toggleShowPickupDateSelector: (showPickSelector: boolean) => void;
  toggleShowReturnDateSelector: (showPickSelector: boolean) => void;
  showPickupDateSelector: boolean;
  defaultReturnStartDate: Date;
}
const DEFAULT_DAYS = 2;
const DEFAULT_MONTHS = 2;
export const StartCalendar = ({
  setReturnDate,
  item,
  toggleShowPickupDateSelector,
  toggleShowReturnDateSelector,
  showPickupDateSelector,
  setPickupDate,
  defaultReturnStartDate,
  selectedReturnDate,
  dispatchRentalPeriod,
  selectedPickupDate,
  shouldBeDisabled
}: StartProps): JSX.Element => {
  const dispatch = useDispatch();
  const defaultPickupRangeStartDate = getDefaultDays(DEFAULT_DAYS);
  const defaultPickupRangeEndDate = new Date(addMonths(new Date(), DEFAULT_MONTHS).toDateString());

  const handleResetReturnDate = () => {
    setReturnDate(undefined);
    dispatch(
      resetReturnDate({
        cartItemId: item.cartItemId
      })
    );
  };

  const handlePickupDateToggle = () => {
    toggleShowPickupDateSelector(!showPickupDateSelector);
    toggleShowReturnDateSelector(false);
  };
  const onSelectingPickupDate = (selectedDate: Date) => {
    setPickupDate(selectedDate);

    const newReturnRangeStartDate = calculateReturnRangeStartDate(
      selectedDate,
      defaultReturnStartDate
    );
    const newReturnRangeEndDate = calculateReturnRangeEndDate(selectedDate, defaultReturnStartDate);
    const hasPickupDate =
      selectedReturnDate &&
      isValidPickupDate({
        selectedDate,
        compareDate: selectedReturnDate,
        returnRangeStartDate: newReturnRangeStartDate,
        returnRangeEndDate: newReturnRangeEndDate
      });

    if (hasPickupDate) {
      dispatchRentalPeriod();
      toggleShowPickupDateSelector(false);
    } else {
      handleResetReturnDate();
      toggleShowPickupDateSelector(false);
      toggleShowReturnDateSelector(true);
    }
  };

  return (
    <div className={styles.contentWrapper}>
      <Calendar
        onDateChange={onSelectingPickupDate}
        rangeStartDate={defaultPickupRangeStartDate}
        rangeEndDate={defaultPickupRangeEndDate}
        title={rm('checkout_calendar_from')}
        selectedDate={selectedPickupDate}
        showDateSelector={showPickupDateSelector}
        toggleDateSelector={handlePickupDateToggle}
        shouldBeDisabled={shouldBeDisabled}
        browseCalendar
      />
    </div>
  );
};
